import React from 'react';
import type { NextPage } from 'next';
import Head from 'next/head';

import { ConsumerTerms as ConsumerTermsView } from 'components/views/ConsumerTerms';

const ConsumerTerms: NextPage = () => (
  <>
    <Head>
      <title>Inköpsvillkor Konsument - Blipp</title>
      <meta property="og:title" content="Inköpsvillkor Konsument - Blipp" />
    </Head>
    <ConsumerTermsView />
  </>
);

export default ConsumerTerms;
